import axios from "axios";
import { config } from "../../../../../enviroment";
import { apolloClientService } from "../../../../../services/apollo-client";

export default function getNotificationAPI(saId,accountId,customerClass) {
    let APIquery = `query{
      notificationDot(input:{
        saId: "`+saId+`",
        accountId:"`+accountId+`",
        isPublic:"LOGGED_IN",
        customerClass:"`+customerClass+`"})
    }`;
    return new Promise((resolve, reject) => {
      axios({
        url: config.urls.COMMUNICATION_SERVICE_BASE_URL,
        method: 'post',
        data: {
          query: APIquery
        }
      })
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

export function meterAlertsCall(
  startDate,
  endDate,
  origin,
  accountId,
  customerClass,
  announcementEndDate
) {
  let APIinput = "";
  const ANNOUNCEMENT_VALUE="ANNOUNCEMENT"
  if (origin === ANNOUNCEMENT_VALUE) {
    APIinput =
      `query{getAnnouncementList(input:{IsPublic:"LOGGED_IN",StartDate:"` +
      startDate +
      `",EndDate:"` +
      announcementEndDate +
      `",CustomerClass:"` +
      customerClass +
      `"}){AnnouncementId,AnnouncementTitle,AnnouncementDescription,IsPublic,ExpirationDateTime,CreateDateTime,StartDate,AnnouncementType,AnnouncementStatus,CustomerClass,IsPublic,IsRead}}`;
  } else {
    APIinput =
      `{getAlerts(input:{origin:"` +
      origin +
      `",
      startDate:"` +
      startDate +
      `",
      endDate:"` +
      endDate +
      `",
      accountId: "` +
      accountId +
      `"  
      })}`;
  }

  return apolloClientService.ApolloClientgqlsCommunication(APIinput, "", "network-only");
}